export const OPEN_MODAL_FRAME_TRANSACTION = 'MODAL_FRAME_MANAGER.OPEN_MODAL_FRAME_TRANSACTION';
export const OPEN_MODAL_FRAME = 'MODAL_FRAME_MANAGER.OPEN_MODAL_FRAME';
export const CLOSE_MODAL_FRAME = 'MODAL_FRAME_MANAGER.CLOSE_MODAL_FRAME';
